var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #231f20;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke-width: 5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M427,238c-4-37-28-116-100-127-8-7-16,2-18,8-8-11-28-31-50-23-26,8-29,19-32,28l-1,2c-10,2-31,8-30,20-7,3-21,15-24,32-8,20-22,68-17,90-22,23-54,73-17,102,24-60,107-101,180-109,70-7,118,57,131,86,4,2,10,2,15-4l2-2c10-8,18-14,11-43-7-24-36-50-50-60Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315,272c-100,12-151,62-169,104l5,2c-9,9-18,29,21,32,19,31,86,97,128,97,66.5-12.7,119.3-63.2,135-129,2-7,3-21,2-34-25-40-67-79-122-72Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M266,339c-2-8-16-22-50-11,6,15,24,39,50,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M347,466l-34-8c-2,0-4-4-3-13,8,0,25-4,26-16,3-9,4-27-11-26-3,1-11,3-16,1-5-1-20-4-27,4-6,9-8,37,16,35,3-1,9,0,6,13l-16,4c-12,1-36,4-32,10,3,5,4.9,1.1,7.9-1.9,6-2,26.1-3.1,40.1,1.9l6-2c8-2,20.9-8.3,37.9,2.7,6-1,12.1.3-.9-4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M345,344c26,17,43-2,48-14-35-18-47,2-48,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.1,212.3c-70.9,7.2-140.5,48.8-140.3,49.5.6,1.5,79.8-46.7,168.4-47.2,36.4-.2,79.9,21,80,20.6.1-.5-34.8-30.5-108.1-23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.8,219.5c.4-.2-8.9-30-3.9-64.9,2-13.8,5.5-23.5,5.4-23.5-.1,0-7.2,17.4-7.7,39.6-.2,11.9,1.5,23.4,2.8,32.1,1.5,10,3.2,16.8,3.4,16.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.3,173.3c3.2-10.9,6.7-18.4,6.6-18.4,0,0-6.7,13.4-10.4,31-2,9.5-2.8,18.8-3.5,25.8-.7,8.1-.9,13.6-.8,13.5.3-.1-.2-24.6,8-52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374.8,175.3c.2,0-3.4-5-9.2-11.5-5-5.7-11.7-13.2-19.7-19.5-15-11.8-30.7-16.2-30.7-16,0,0,8.4,2.8,18.7,8.9,26,15.4,40.5,38.4,40.9,38.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195,466.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.8,395.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M255.1,441.1c-.2-.2-32.2,13.2-61.2,27.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.4,432.1c-.2-.2-33.9,8-64.8,18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M253.8,423.1c-.2-.3-35-11.5-67.3-19.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M417.8,395.2c-.2-.2-33.3,10.3-63.4,22.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M435.2,417.6c-.1-.3-37.4,2.4-72.4,7.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M419.2,447.7c0-.3-34.1-7.3-66.2-11.6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape4);
export default __webpack_public_path__ + "static/media/shape4.b54454e7b7df6508e9bbb4b68a2607cb.svg";
export { ForwardRef as ReactComponent };